// extracted by mini-css-extract-plugin
module.exports = {"EditSkeleton":"_2qYnJW2kbFuC9n8qRbHBEi"};